
import { Vue, Component } from "vue-property-decorator";
import Settings from "./Settings.vue";
import NewMessage from "./NewMessage.vue";
import * as InboxStore from "../store/modules/inbox";
import Messages, { Message } from "../core/messages";
import firebase from "../utils/fcm";
import Snack from "../utils/snack";

@Component({
  components: {
    Settings,
    NewMessage
  }
})
export default class Inbox extends Vue {
  // Props
  // Data
  // Computed
  get userId() {
    return InboxStore.getters.userId;
  }
  get settingsIsVisible() {
    return InboxStore.getters.settingsIsVisible;
  }
  get newMessageIsVisible() {
    return InboxStore.getters.newMessageIsVisible;
  }
  get messages() {
    return InboxStore.getters.messages;
  }
  get language() {
    return InboxStore.getters.language;
  }

  // Methods
  loadMessages() {
    InboxStore.actions.loadMessages();
  }

  hideSettings() {
    InboxStore.mutations.hideSettings();
    this.loadMessages();
  }
  hideNewMessage() {
    InboxStore.mutations.hideNewMessage();
  }

  revokeMessage(message: Message) {
    InboxStore.actions.revokeMessage(message);
  }

  async markMessageAsViewed(message: Message) {
    await Messages.registerEngagement(message.userId, message.id!, "seen");
  }
  // Life-cycle hooks
  async mounted() {
    try {
      const cloudMessaging = firebase.messaging();
      await cloudMessaging.requestPermission();
      const token = await cloudMessaging.getToken({
        vapidKey:
          "BNTMPuJ4kfV9l8byIz76LSeORAxfu37QneVw_9uhQ7t0Om-KjJJsVNnxBP_1pUnLEDw8NIrgpK_Jd4GmeGwqwXE"
      });
      InboxStore.mutations.setFcmToken(token);
      cloudMessaging.onMessage((msg: any) => {
        Snack.info("Received new message. Reloading messages");
        this.loadMessages();
      });
    } catch (err) {
      Snack.error("Push notification permissions denied");
      return;
    }
  }
}
